import { lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

const WelcomeContainer = lazy(() => import("@/public/modules/welcome/WelcomeContainer"));
const TermsContainer = lazy(() => import("@/public/modules/terms/termsContainer"));
const PolicyContainer = lazy(() => import("@/public/modules/policy/policyContainer"));

const AppRouting = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<WelcomeContainer />} />
                <Route path="/terms" element={<TermsContainer />} />
                <Route path="/policy" element={<PolicyContainer />} />                
                <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    )
}
export default AppRouting;